export const meta = { id: 'O08', slug: 'criar-competencia', title: 'Como criar uma Competência', description: 'Cadastre competências que possam ser avaliadas e acompanhadas no desenvolvimento.', profile: 'owner', category: 'metodologia', type: 'task', status: 'published', order: 380, keywords: ['competência','criar competência','desenvolvimento','diagnóstico'], previous: 'O07', next: 'O09', related: ['O09','O10','A02'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar uma Competência

Uma competência deve representar algo relevante para o desenvolvimento e observável na prática.

<HelpImage pendingId="O08.2" alt="Cadastro ou edição de Competência" />

<Steps>
  <Step title="Defina o que a competência significa">Escreva com clareza o comportamento ou capacidade que será desenvolvido.</Step>
  <Step title="Relacione à metodologia">Inclua a competência na estrutura correta.</Step>
  <Step title="Planeje os níveis">Pense em diferenças reais de desenvolvimento.</Step>
  <Step title="Crie descritores observáveis">Explique como cada nível se manifesta na prática.</Step>
</Steps>

<Callout type="tip">Antes de cadastrar, pergunte: esta competência ajudará alguém a avaliar, desenvolver e acompanhar um comportamento relevante?</Callout>
